// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './Footer.css';  // Don't forget to create this file

function Footer() {
  return (
    <footer className="footer-container">
      <Container>
        <Row className="align-items-center">
          <Col md={4}>
            <h5 className="brand-name">Solutions Inc</h5>
            <p className="brand-tagline">AI Done Right</p>
          </Col>
          <Col md={8}>
            <div className="footer-links">
              <Link to="/privacy-policy">Privacy</Link>
              <Link to="/cookie-policy">Cookies</Link>
              <Link to="/terms-and-conditions">Terms</Link>
              <Link to="/disclaimer">Disclaimer</Link>
              <Link to="/acceptable-use-policy">Use</Link>
            </div>
          </Col>
        </Row>
        <Row className="copyright-row">
          <Col>
            <p className="mb-0">&copy; {new Date().getFullYear()} Solutions Inc. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
